<template>
    <i class="tooltip tooltip-icon" @click="toggleTooltip" :active="ttVisible" :open="open">
        <div class="tt-content">
            <slot>
                {{message}}
            </slot>
            <!--<span class=" close-button" >Got it</span>-->
            <i />
        </div>
    </i>

</template>

<script lang="ts" setup>
    import {ref} from "vue";
    defineProps(["message", "open"]);
    const ttVisible = ref();

    function toggleTooltip() {
        //ttVisible.value = !ttVisible.value;
    }

</script>
